import React from "react";

type SearchBarProps = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({ value, onChange, onSubmit }) => (
  <form
    onSubmit={onSubmit}
    className="fixed top-8 left-1/2 transform -translate-x-1/2 z-50 bg-white/95 border border-gray-200 rounded-lg shadow flex gap-2 px-4 py-2"
  >
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder="IDX 또는 주소로 검색"
      className="px-3 py-1 rounded border border-gray-300 min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-200"
    />
    <button
      type="submit"
      className="px-3 py-1 rounded bg-blue-600 text-white hover:bg-blue-700 transition-colors"
    >
      검색
    </button>
  </form>
);

export default SearchBar;
